import {DialogButtonClickHandleResultEnum} from "../../../../../dialog/dialog.service.interface";
import {RegistrationExternalLinkHandler} from "../../registration.external-link-handler";
import {IOpenRegistrationOptions} from "../../registration.external-link-handler.interface";

export class RomaniaRegistrationExternalLinkHandler extends RegistrationExternalLinkHandler {
    private _openDialogModal(): void {
        this.services.dialog.showSimpleTextModal({
            text: this.services.translation.translate('WINNER_MIGRATION_HYBRID_TEXT'),
            hideCloseButton: true,
            disableFullscreenMobile: false,
            iconSvg: this.services.theme.currentTheme.icons.sideMenuClub888,
            buttons: [
                {
                    text: this.services.translation.translate('WINNER_MIGRATION_HYBRID_SIGN_UP_HERE'),
                    buttonPreset: 'primary',
                    onClick: async () => {
                         this.services.hybrid.openExternalLink(this.services.configuration.servicesConfigs.WinnerMigration.newAppLink);
                         return DialogButtonClickHandleResultEnum.KeepDialogOpen
                    }
                }
            ]
        });
    }

    //temporary removing hybrid openDialogModal due to Winners request
    async openRegistration(options?: IOpenRegistrationOptions): Promise<void> {     
        if(this.services.configuration.servicesConfigs.WinnerMigration.enforceRegistrationRedirect && !this.services.device.hybrid.inCasino) {
            this.services.location.redirect(this.services.configuration.servicesConfigs.WinnerMigration.registrationRedirectUrl);
            return;
        }    
        
        return await super.openRegistration(options);
    }
}